module.exports = __webpack_public_path__ + "img/8012.f73b591d.gif";